var MyAccount = $.extend({/* MyAccount */}, BaseComponent, {

	componentSelector: '.my-account-menu',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		$(element).mouseenter((function(event) {
			$(event.currentTarget).addClass('active');
		}).bind(this));

		$(element).mouseleave((function(event) {
			$(event.currentTarget).removeClass('active');
		}).bind(this));
	}

})